import { DEFAULT_FAVICON_HREF } from '#pplx/frontend/apps/ask/spa/metadata/metadata.js';
import React, { useEffect } from 'react';
const FAVICON_LINK_SELECTOR = 'link[rel~="icon"]';
const DEFAULT_FAVICON_HREF_DATA_KEY = 'defaultFaviconHref';
function getDefaultFaviconHref(link) {
    link.dataset[DEFAULT_FAVICON_HREF_DATA_KEY] ||= link.getAttribute('href') ?? '';
    return link.dataset[DEFAULT_FAVICON_HREF_DATA_KEY] || DEFAULT_FAVICON_HREF;
}
function isEnvSpecificFaviconHost(hostname) {
    const normalizedHostname = hostname.toLowerCase();
    return (normalizedHostname.includes('localhost') ||
        normalizedHostname.includes('testing') ||
        normalizedHostname.includes('staging') ||
        normalizedHostname.endsWith('.preview.i.perplexity.ai'));
}
function setDefaultFaviconHref() {
    const usesEnvSpecificFavicon = isEnvSpecificFaviconHost(window.location.hostname);
    document.querySelectorAll(FAVICON_LINK_SELECTOR).forEach((link) => {
        const defaultHref = getDefaultFaviconHref(link);
        const targetHref = usesEnvSpecificFavicon ? DEFAULT_FAVICON_HREF : defaultHref;
        if (link.getAttribute('href') !== targetHref) {
            link.setAttribute('href', targetHref);
        }
    });
}
function createCustomFavicon(href) {
    const staticLinks = Array.from(document.head.querySelectorAll(FAVICON_LINK_SELECTOR), (link) => ({ link, nextSibling: link.nextSibling }));
    staticLinks.forEach(({ link }) => link.remove());
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = href;
    document.head.append(link);
    return { link, staticLinks };
}
function restoreStaticFavicons(customFavicon) {
    customFavicon.link.remove();
    [...customFavicon.staticLinks].reverse().forEach(({ link, nextSibling }) => {
        document.head.insertBefore(link, nextSibling?.parentNode === document.head ? nextSibling : null);
    });
}
export const DocumentTitle = React.memo(function DocumentTitle(props) {
    const title = props.metadata?.title || 'Perplexity';
    const faviconHref = props.metadata?.icons?.icon ?? DEFAULT_FAVICON_HREF;
    const customFaviconRef = React.useRef(null);
    useEffect(() => {
        document.title = title;
    }, [title]);
    useEffect(() => () => {
        document.title = 'Perplexity';
    }, []);
    useEffect(() => {
        if (faviconHref === DEFAULT_FAVICON_HREF) {
            if (customFaviconRef.current) {
                restoreStaticFavicons(customFaviconRef.current);
                customFaviconRef.current = null;
            }
            setDefaultFaviconHref();
            return;
        }
        customFaviconRef.current ??= createCustomFavicon(faviconHref);
        customFaviconRef.current.link.setAttribute('href', faviconHref);
    }, [faviconHref]);
    useEffect(() => () => {
        if (customFaviconRef.current) {
            restoreStaticFavicons(customFaviconRef.current);
            customFaviconRef.current = null;
        }
        setDefaultFaviconHref();
    }, []);
    return null;
});
//# sourceMappingURL=DocumentTitle.js.map